/*
  SVG markup shared by the two custom play-button styles on this site: the
  standalone `.cvp` placeholder and Elementor's `.elementor-custom-embed-play`
  video-widget icon. `prefix` picks which class family/CSS variable a given
  instance uses (`cvp` or `cv`), so the two can be styled independently.
*/

export function buildPlayButtonIcon(prefix) {
    var wrapper = document.createElement('span');
    wrapper.className = prefix + '-btn';

    var ring = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    ring.setAttribute('class', prefix + '-ring');
    ring.setAttribute('viewBox', '0 0 100 100');

    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('cx', '50');
    circle.setAttribute('cy', '50');
    circle.setAttribute('r', '46');
    ring.appendChild(circle);

    var tri = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    tri.setAttribute('class', prefix + '-tri');
    tri.setAttribute('viewBox', '0 0 64 64');

    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M26 20.5c0-2.2 2.4-3.6 4.3-2.5l16.5 9.6c1.9 1.1 1.9 3.9 0 5L30.3 42.2c-1.9 1.1-4.3-.3-4.3-2.5V20.5z');
    tri.appendChild(path);

    wrapper.appendChild(ring);
    wrapper.appendChild(tri);

    var r = circle.r.baseVal.value;
    var circumference = 2 * Math.PI * r;
    circle.style.strokeDasharray = String(circumference);
    circle.style.strokeDashoffset = String(circumference);
    circle.style.setProperty('--' + prefix + '-circ', String(circumference));

    return wrapper;
}
